module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "hasSlot": true,
      "showEdit": true,
      "showClone": true,
      "showDelete": true,
      "tableData": _vm.results,
      "tableTitle": "Lookup Profiles",
      "fields": [{
          header: 'Service Provider',
          prop: function (profile) { return profile.serviceProvider !== null ? profile.serviceProvider.name : ''; }
        },
        {
          header: 'Service Contract',
          prop: 'serviceContract'
        },
        {
          header: 'Description',
          prop: 'description'
        },
        {
          header: 'Address',
          prop: function (profile) { return profile.serviceProvider !== null && profile.serviceProvider.address !== null ? _vm.displayLocation(profile.serviceProvider.address) : ''; }
        }
      ]
    },
    on: {
      "table-edit-request": _vm.handleEdit,
      "table-delete-request": _vm.handleDelete,
      "table-clone-request": _vm.clone
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2d2a006"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/RateAssistSearchResults.vue
// module id = 2272
// module chunks = 1